import { SelectPreviousCertificationComponent } from '@aca-new/app/pages/book/pages/food-certification/shared/components/food-general-information/shared/components/select-previous-certification/select-previous-certification.component';
import { ISelectPreviousCertification } from '@aca-new/app/pages/book/pages/food-certification/shared/components/food-general-information/shared/models/interfaces/select-previous-certification.interface';
import { DialogRef } from '@aca-new/app/shared/components/modal/shared/classes/dialog.ref';
import { DialogService } from '@aca-new/app/shared/components/modal/shared/services/dialog.service';
import { EPostMessageType } from '@aca-new/app/shared/models/enums/post-message-type.enum';
import { EServiceType } from '@aca-new/app/shared/models/enums/service-type.enum';
import { AcaMessageService } from '@aca-new/app/shared/services/post-message-services/aca-message/aca-message.service';
import { inject, Injectable, Injector } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { QimaOptionalType } from '@qima/ngx-qima';
import { map, Observable } from 'rxjs';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class SelectPreviousCertificationService {
  private readonly _dialog = inject(DialogService);
  private readonly _injector = inject(Injector);

  /**
   * Open select previous certification dialog
   * @param {string} draftId - The draft ID
   * @param {EServiceType} serviceType - The type of service (e.g. BRCGS)
   * @returns {Observable<ISelectPreviousCertification | undefined>} Observable that emits dialog data when closed
   */
  public openSelectPreviousCertificationDialog$(draftId: string, serviceType: EServiceType = EServiceType.BRCGS): Observable<ISelectPreviousCertification | undefined> {
    const dialogRef: DialogRef<ISelectPreviousCertification> = this._dialog.open(SelectPreviousCertificationComponent, {
      data: { draftId, serviceType },
    });

    return dialogRef
      .afterClosed$()
      .pipe(map((responseData: QimaOptionalType<ISelectPreviousCertification>): ISelectPreviousCertification | undefined => responseData ?? undefined));
  }

  public onSelectPreviousCertificationShow(draftId: string): void {
    this.openSelectPreviousCertificationDialog$(draftId, EServiceType.GGAP)
      .pipe(untilDestroyed(this))
      .subscribe((data): void => {
        const acaMessageService = this._injector.get(AcaMessageService);

        acaMessageService.postMessageToAca({
          type: EPostMessageType.SELECT_PREVIOUS_CERTIFICATION_SHOW,
          data: { ...data },
        });
      });
  }
}
